import { connect }         from 'react-redux';
import { Dispatch }        from "redux";
import { ActionTypes }     from 'actions/types';
import { reducerType }     from 'reducer';
import DropDown            from './dropdown';
import { colors }          from 'utils/colors';
import { words }           from 'utils/dictionary';
import { navbarDropdowns } from 'utils/constants';

import handleNBClick       from './handleNvabarClick';
import logo                from 'images/yisumaticaLogo.png';
import { 
  manualNavStateType, 
  menusStateType, 
  sizeStateType
}                          from 'reducer/types';

import { pages }           from 'utils/constants'

import { SET_LANG }        from 'actions/componentsActions';
import { langType }        from 'types';
import { SET_MENUS_STATE } from 'actions/menusActions';
import { makeStyles }           from 'makeStyles';

const langs: { [key: string]: string } = { heb: `عربي`, ara: `עברית` }

var clsx = require('classnames')

const useStyles = makeStyles()(() => ({
    root: {
        position:        'fixed',
        top:             0,
        left:            0,
        width:           '100vw',
        backgroundColor: '#FFF',
        borderBottom:    '1px solid #DDD',
        transition:      'all 0.5s',
        boxShadow:       '3px 3px 3px rgba(0,0,0,0.05)'
    },
    container: {
      position:        'absolute',
      top:             0,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'space-evenly',
      backgroundColor: '#FFF'
    },
    selector: {
      cursor: 'pointer',
      '&:hover': {
        opacity: 0.5
      }
    },
    big: {
      fontSize: 20,
      padding:  2
    },
    icon_container: {
      position:        'absolute',
      right:           0,
      width:           '15vw',
     // height:          100,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      cursor:          'pointer',
    },
    icon: {
      color:    colors.darkText,
      fontSize: 28
    },
    logoContainer: {
      position:       'absolute',
      right:          0,
      width:          '15vw',
    //  height:         100,
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'flex-end',
    },
    logo: {
      width:              '85%',
      height:             50,
      backgroundImage:    `url(${ logo })`,
      backgroundPosition: 'left',
      backgroundSize:     'contain',
      backgroundRepeat:   'no-repeat',
    },
    groupUrl: {
      position:       'absolute',
      minWidth:       '100vw',
      height:         '100%',
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center',
      textAlign:      'center',
      fontSize:       25,
      fontWeight:     'bold'
    },
    new: {
      position:       'absolute',
      display:        'flex',
      flexFlow:       'row',
      alignItems:     'center',
      justifyContent: 'center',
      fontSize:       18,
      fontWeight:     'bold',
      color:          colors.primary,
      transform:      'translate(0px, 50px)'
    }
}))

type ContainerProps = {
  sizeState:            sizeStateType;
  menusState:           menusStateType;
  openDropDown:         string;
  page:                 string;
  lang:                 string;
  links:                string[];
  selfTeaching:         string[];
  manualNavState:       manualNavStateType;
  containerStyle:       { [key: string]: any; }
  setLang:              (val: string) => void;
  setMenusState:        (payload: menusStateType) => void;
}

const Container: React.FC<ContainerProps> = ({ 
  sizeState,
  menusState,
  openDropDown,
  page,
  lang,
  links,
  selfTeaching,
  manualNavState,
  containerStyle,
  setLang,
  setMenusState
}) => {

  const { classes } = useStyles();

  return (
   
      <div 
         className = { classes.container }
         style     = { containerStyle }
      >
          <>
                {
                  sizeState.size[0] >= 850 
                  &&
                  pages.map((val) => {

                    const DDItem = navbarDropdowns.includes(val);

                    return(
                      <div
                        key       = { `${ val }:::` }
                        className = { DDItem ? undefined : sizeState.wideScreen ? clsx(classes.selector, classes.big) : classes.selector }
                        onClick   = { () => { handleNBClick(val) }}
                        style     = {{
                           color:  (val === page && val !== 'about') ? colors.blue : undefined,
                           border: `2px solid ${ manualNavState.manualOn && manualNavState.manualVal === val ? colors.blue : 'transparent' }`  
                        }}
                      >
                        { 
                           DDItem ? (
                              <DropDown
                                variant         = { val }
                                dropDownItems   = { val === 'links' ? links : selfTeaching }
                                manualVal       = { manualNavState.manualVal }
                                manualOn        = { manualNavState.manualOn }
                                openDropDown    = { openDropDown }
                                setOpenDropDown = { (val: string) => { setMenusState({ ...menusState, openDropDown: val }) }}
                                handlePageClick = { handleNBClick }
                              />
                           )
                           :
                           words[val][lang] 
                        }
                      </div>
                    )
                  })
                }
                <div 
                   className = { sizeState.wideScreen ? clsx(classes.selector, classes.big) : classes.selector }
                   onClick   = { () => { setLang( lang === 'heb' ? 'ara' : 'heb' ) }}
                   style     = {{ border: `2px solid ${ manualNavState.manualOn && manualNavState.manualVal === langs[lang] ? colors.blue : 'transparent' }` }}
                >
                  { langs[lang] }
                </div> 
          </>
      </div>
  );
}




const mapStateToProps = (reducer: reducerType) => {

  return {
    sizeState:       reducer.size,
    lang:            reducer.components.lang,
    page:            reducer.page.page,
    menusState:      reducer.menus,
    openDropDown:    reducer.menus.openDropDown,
    manualNavState:  reducer.manualNav,
}};

const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
  setLang:       (payload: langType) => dispatch(SET_LANG(payload)),
  setMenusState: (payload: menusStateType) => dispatch(SET_MENUS_STATE(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);



